module.exports = __webpack_public_path__ + "media/images/emblems/Muri-blason-24232a9ca5c235d3ad94e5bca7d9ea33.png";